import script from "./MobileProfessionSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileProfessionSearch.vue?vue&type=script&lang=ts&setup=true"

import "./MobileProfessionSearch.vue?vue&type=style&index=0&id=79c9e730&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c9e730"]])

export default __exports__